import React, { useEffect } from "react";
import translate from "../../reusable/translate";
import "../../materialCommitment/styleSheets/MaterialCommitment.css";

import { v4 as uuidv4 } from "uuid";
import Operation from "./Operation";
import Tooltip from "../../materialCommitment/tooltip/Tooltip";
import {
  getCommitmentTypeId,
  isMaterialOrGD
} from "../../materialCommitment/helpers/Categories";

import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";

import commitmentSlice from "../../../state/slices/commitmentSlice";
import validatorSlice from "../../../state/slices/validatorSlice";

const OperationsContainer = ({
  availableOperations,
  meterRef,
  operationsRef
}) => {
  const { commitment, validators, language } = useSelector(state => state);
  const dispatch = useDispatch();
  const { changeOperationsValidator } = bindActionCreators(
    validatorSlice.actions,
    dispatch
  );
  const { addOperation, changePublicitySelection } = bindActionCreators(
    commitmentSlice.actions,
    dispatch
  );

  const addNewOperation = () => {
    addOperation({
      operationId: uuidv4(),
      operationTitle_fi_FI: "",
      operationTitle_sv_SE: "",
      operationTitle_en_US: "",
      meters: [],
      operationDescription_fi_FI: "",
      operationDescription_sv_SE: "",
      operationDescription_en_US: "",
      operationTheme: "",
      reports: [],
      key: String(Math.random()),
      published: false,
      privateOperation: false,
      isNew: true
    });
  };

  useEffect(() => {
    if (!commitment.operations.length) {
      addNewOperation();
    }
  }, []);

  useEffect(() => {
    const id = getCommitmentTypeId(commitment.commitmentType);
    const fetchPublicity = async () => {
      const result = await fetch(
        `/o/commitment2050-service/commitmentapi/categories/${id}`
      ).then(res => res.json());
      const category = result.children.find(
        child => child.categoryId === commitment.commitmentCategoryId.toString()
      );
      changePublicitySelection(!!category.properties.allowToSelectPublicity);
    };

    if (isMaterialOrGD(commitment.commitmentType)) {
      fetchPublicity();
    }
  }, []);

  return (
    <div
      className={`operations-container ${
        validators.operations ? "" : "operations-container-validated"
      }`}
      ref={operationsRef}
    >
      <div className={"flex-column border-bottom page-break"}>
        <Header language={language} />

        {commitment.status === "approved" && (
          <div>
            <p>
              <b>
                {translate({
                  textKey: "sit.commitment.operations.locked",
                  languageOverride: language
                })}
              </b>
            </p>
          </div>
        )}

        {commitment.operations.map((operation, index) => (
          <div key={operation.operationId} className="operation">
            <Operation
              index={index}
              operation={{
                ...operation,
                published: commitment.status === "approved" && !operation.isNew
              }}
              availableOperations={availableOperations}
              meterRef={meterRef}
            />
          </div>
        ))}

        <button
          className="add-button"
          onClick={() => {
            changeOperationsValidator(true);
            addNewOperation();
          }}
        >
          {translate({
            textKey: "sit.commitment.operations.addOperation.871646",
            fallback: "sit.commitment.operations.addOperation",
            languageOverride: language
          })}
          <i className="fas fa-plus-circle" />
        </button>
      </div>
    </div>
  );
};

export default OperationsContainer;

const Header = ({ language }) => {
  return (
    <div className="flex-row items-center margin-top-bot">
      <h3 className="h3">
        {translate({
          textKey: "sit.commitment.operations.871646",
          languageOverride: language
        })}
      </h3>
      <Tooltip
        textKey={"tooltip.operationsInfo.871646"}
        languageOverride={language}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/circularEconomyCommitment/operation/OperationsContainer.jsx